<template>
  <div :class="className" :style="{height:height,width:width}"></div>
</template>

<script>
import echarts from "echarts";
// require('echarts/theme/macarons') // echarts 主题
export default {
  props: {
    className: {
      type: String,
      default: "lineChart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "300px"
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      }
    }
  },
  methods: {
    setOptions({ expectedData, actualData, week } = {}) {
      this.chart.clear();
      if (expectedData.length < 8) {
        this.chart.setOption({
          xAxis: {
            name: "时间轴",
            data: week,
            type: "category",
            show: true,
            // nameGap: '-30',
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              interval: 0
              // rotate: -90,
            },
            
          },
          grid: {
            width: "90%",
            left: 0,
            right: 0,
            bottom: 20,
            top: 30,
            containLabel: true
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross"
            }
            // padding: [5, 10]
          },
          yAxis: {
            name: "流水分析",
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              lineStyle: {
                type: "dashed"
              }
            }
          },
          series: [
            {
              name: "流水",
              itemStyle: {
                normal: {
                  color: "#FF005A",
                  lineStyle: {
                    color: "#FF005A",
                    width: 2
                  }
                }
              },
              smooth: true,
              type: "line",
              data: expectedData,
              animationDuration: 2800,
              animationEasing: "cubicInOut"
            },
            {
              name: "利润",
              smooth: true,
              type: "line",
              itemStyle: {
                normal: {
                  color: "#3888fa",
                  lineStyle: {
                    color: "#3888fa",
                    width: 2
                  }
                }
              },
              data: actualData,
              animationDuration: 2800,
              animationEasing: "quadraticOut"
            }
          ]
        });
      } else if(expectedData.length>7){
        this.chart.setOption({
          dataZoom: [
            {
              id: "dataZoomX",
              type: "slider",
              // xAxisIndex: [0],
              start: 0,
              end: 20,
              handleSize: 8,
              showDetail: false,
              filterMode: "empty"
            },
            {
              id: "dataZoomY",
              type: "slider",
              yAxisIndex: [0],
              filterMode: "empty",
              width: 12,
              height: "50%",
              showDataShadow: false,
              left: "93%",
              handleSize: 8
            }
          ],
          xAxis: {
            name: "时间轴",
            data: week,
            type: "category",
            show: true,
            // nameGap: '-30',
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              interval: 0
              // rotate: -90,
            },
            min: 0,
            // nameRotate: 270
          },
          grid: {
            width: "92%",
            left: 0,
            // right: 0,
            // bottom: 20,
            top: 30,
            containLabel: true
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross"
            }
            // padding: [5, 10]
          },
          yAxis: {
            name: "流水分析",
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              lineStyle: {
                type: "dashed"
              }
            }
          },
          series: [
            {
              name: "流水",
              itemStyle: {
                normal: {
                  color: "#FF005A",
                  lineStyle: {
                    color: "#FF005A",
                    width: 2
                  }
                }
              },
              smooth: true,
              type: "line",
              data: expectedData,
              animationDuration: 2800,
              animationEasing: "cubicInOut"
            },
            {
              name: "利润",
              smooth: true,
              type: "line",
              itemStyle: {
                normal: {
                  color: "#3888fa",
                  lineStyle: {
                    color: "#3888fa",
                    width: 2
                  }
                }
              },
              data: actualData,
              animationDuration: 2800,
              animationEasing: "quadraticOut"
            }
          ]
        });
      }
    },
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions(this.chartData);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/lineEchart.vue